(function() {
  var MODULE_SELECTOR = '[data-cpilot-module="cpilot-collection-card-family-navigation"]';
  var LINK_SELECTOR = '[data-cpilot-collection-card-family-navigation-link]';
  var EVENT_NAME = 'collection_card_family_navigation_clicked';

  function toOptionalString(value) {
    if (value === undefined || value === null || value === '') {
      return undefined;
    }

    return value;
  }

  function toOptionalInteger(value) {
    if (value === undefined || value === null || value === '') {
      return undefined;
    }

    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
  }

  function hasPostHogCapture() {
    return (
      typeof window.posthog !== 'undefined' &&
      typeof window.posthog.capture === 'function'
    );
  }

  function buildEventProps(nav, link) {
    return {
      store_key: toOptionalString(nav.dataset.cpilotStore),
      surface: toOptionalString(nav.dataset.cpilotSurface),
      slice_key: toOptionalString(nav.dataset.cpilotSliceKey),
      implementation_lineage_id: toOptionalInteger(nav.dataset.cpilotImplementationLineageId),
      module_key: toOptionalString(nav.dataset.cpilotModuleKey),
      module_version: toOptionalString(nav.dataset.cpilotModuleVersion),
      tee_family: toOptionalString(nav.dataset.cpilotFamily),
      collection_handle: toOptionalString(nav.dataset.cpilotCollectionHandle),
      source_product_handle: toOptionalString(nav.dataset.cpilotSourceProductHandle),
      source_product_id: toOptionalString(nav.dataset.cpilotSourceProductId),
      source_colour_label: toOptionalString(nav.dataset.cpilotSourceColourLabel),
      target_product_handle: toOptionalString(link.dataset.cpilotTargetProductHandle),
      target_product_id: toOptionalString(link.dataset.cpilotTargetProductId),
      target_colour_label: toOptionalString(link.dataset.cpilotTargetColourLabel),
      click_type: toOptionalString(link.dataset.cpilotClickType),
      visible_swatch_count: toOptionalInteger(nav.dataset.cpilotVisibleSwatchCount),
      hidden_swatch_count: toOptionalInteger(nav.dataset.cpilotHiddenSwatchCount),
      position_index: toOptionalInteger(link.dataset.cpilotPositionIndex),
      target_url: toOptionalString(link.dataset.cpilotTargetUrl)
    };
  }

  function captureNavigationClick(nav, link) {
    if (!hasPostHogCapture()) {
      return;
    }

    window.posthog.capture(EVENT_NAME, buildEventProps(nav, link));
  }

  function shouldIgnoreClick(event, link) {
    return (
      event.defaultPrevented ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0 ||
      !link ||
      !link.href ||
      link.getAttribute('aria-current') === 'true'
    );
  }

  function bindModule(nav) {
    if (!nav || nav.dataset.cpilotTrackingBound === 'true') {
      return;
    }

    nav.dataset.cpilotTrackingBound = 'true';

    nav.addEventListener('click', function(event) {
      var link = event.target.closest(LINK_SELECTOR);
      if (!link || !nav.contains(link) || shouldIgnoreClick(event, link)) {
        return;
      }

      captureNavigationClick(nav, link);
    });
  }

  function initCommercePilotCollectionCardFamilyNavigationTracking(root) {
    var scope = root || document;
    var modules = [];

    if (scope.matches && scope.matches(MODULE_SELECTOR)) {
      modules.push(scope);
    }

    scope.querySelectorAll(MODULE_SELECTOR).forEach(function(nav) {
      modules.push(nav);
    });

    modules.forEach(bindModule);
  }

  window.CommercePilotCollectionCardFamilyNavigationTracking =
    window.CommercePilotCollectionCardFamilyNavigationTracking || {};
  window.CommercePilotCollectionCardFamilyNavigationTracking.init =
    initCommercePilotCollectionCardFamilyNavigationTracking;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCommercePilotCollectionCardFamilyNavigationTracking(document);
    }, { once: true });
  } else {
    initCommercePilotCollectionCardFamilyNavigationTracking(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initCommercePilotCollectionCardFamilyNavigationTracking(event.target || document);
  });
})();
